import { ErrorHandler, Injectable } from '@angular/core';

import { AzureLoggerService } from './AzureLoggerService';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
    public constructor(private _azureLoggerService: AzureLoggerService) {
        super();
    }

    public handleError(error): void {
        if (
            error.message &&
            error.message.startsWith(
                'NG0100: ExpressionChangedAfterItHasBeenCheckedError',
            )
        ) {
            return;
        }

        this._azureLoggerService.logException(error);
        super.handleError(error);
    }
}
